import { css } from "styled-components";
import { Card } from "../../../../components/Card";
import { Grid } from "../../components/ArticleCardGrid";
import { textUppercaseMixin } from "../../../../skins/shared/mixins/typography";
import { BladeHeaderDefault } from "../../../../molecules/BladeHeaderDefault";
export const riotProductSkin = (chroma, paletteTokens) => css `
  & {
    padding: ${chroma.spacers.bladeEdge.topLarge} 0 ${chroma.spacers.bladeEdge.bottomLarge};
  }

  ${BladeHeaderDefault} {
    margin-bottom: ${chroma.spacers.variable.l};
  }

  ${Grid} {
    display: grid;
    gap: ${chroma.spacers.variable.l} ${chroma.spacers.variable.m};
    grid-template-columns: repeat(3, minmax(0, 1fr));

    ${chroma.mediaQueries.tabletDown} {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }

    ${chroma.mediaQueries.mobileDown} {
      grid-template-columns: repeat(1, minmax(0, 1fr));
    }
  }

  ${Card}.action {
    cursor: pointer;
  }

  .show-more {
    margin-top: ${chroma.spacers.variable.l};
  }

  .divider {
    flex: 1;
    height: 1px;
    background-color: ${paletteTokens.keyline};
  }

  .button-container {
    display: flex;
    justify-content: center;
  }

  .cta {
    display: flex;
    justify-content: space-between;
    border-top: 1px solid ${paletteTokens.accents1};
    padding-top: ${chroma.spacers.variable.m};
    ${chroma.typography.body3}
    ${textUppercaseMixin}
    font-weight: bold;
    vertical-align: middle;
    color: ${paletteTokens.bladetext1};

    .icon-plus {
      background-color: ${paletteTokens.accents1};
      height: 20px;
      width: 20px;
      margin: auto 0 auto 4px;
    }

    &:hover {
      color: ${paletteTokens.accents1};

      .icon-plus {
        background-color: ${paletteTokens.accents1};
      }
    }
  }
`;
//# sourceMappingURL=index.js.map